var map = {
	"./1.png": 63696,
	"./auth-bg.png": 8411,
	"./auth-screens.png": 16915,
	"./city.png": 34460,
	"./image.png": 16382,
	"./instagram.png": 92493,
	"./layout/aside-calendar.png": 3527,
	"./layout/aside-courier-activity.png": 55288,
	"./layout/aside-filters.png": 55364,
	"./layout/aside-segments.png": 13152,
	"./layout/aside-shipment-history.png": 53444,
	"./layout/dark-header.png": 95504,
	"./layout/dark-sidebar.png": 50723,
	"./layout/dark.png": 23512,
	"./layout/demo1-dark.png": 26539,
	"./layout/demo1-light.png": 66099,
	"./layout/demo23-dark.png": 26947,
	"./layout/demo23-light.png": 72635,
	"./layout/light-header.png": 27906,
	"./layout/light-sidebar.png": 51465,
	"./layout/light.png": 85962,
	"./layout/toolbar-accounting.png": 61461,
	"./layout/toolbar-classic.png": 33572,
	"./layout/toolbar-extended.png": 34973,
	"./layout/toolbar-reports.png": 41909,
	"./layout/toolbar-saas.png": 62262,
	"./livestream.png": 86395,
	"./menu-header-dark.png": 67615,
	"./outdoor.png": 54541,
	"./pattern-2.png": 74046,
	"./portfolio.png": 59485,
	"./qr-code.png": 51976,
	"./qr.png": 82816,
	"./search-bg.png": 10865,
	"./sellproduct.png": 21568,
	"./showcase.png": 31946,
	"./thumb_live.png": 39412,
	"./thumb_video.png": 8765,
	"./tick_blue.png": 74071,
	"./tick_yellow.png": 70883,
	"./track-order.png": 64223,
	"./youtube.png": 62830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87214;